// import React, { useState } from 'react';
// import SellerRegModal from '../../components/AdminModal/SellerRegModal';

// function UserSellers() {
//   const [customers, setCustomers] = useState([
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Inactive" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Inactive" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Inactive" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//   ]);

//   // Function to handle the status change
//   const handleStatusChange = (index, newStatus) => {
//     const updatedCustomers = [...customers];
//     updatedCustomers[index].status = newStatus === "Block" ? "Inactive" : "Active";
//     setCustomers(updatedCustomers);
//   };

//   return (
//     <div className="container mx-auto p-4">
//       {/* Add Customer Button */}
//       <div className="flex justify-end mb-4">
//         {/* <button
//           className="bg-green-500 text-white px-4 py-2 w-40 rounded hover:bg-green-600 "
//           aria-label="Add a new customer"
//         >
//           Add Seller
//         </button> */}
//         <SellerRegModal/>
//       </div>

//       {/* Responsive Table */}
//       <div className="overflow-x-auto max-w-full border rounded-xl mt-10">
//         <table className="min-w-full border border-gray-200">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Customer Name</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Email Id</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Phone Number</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Join Date</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Status</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Change Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {customers.map((customer, index) => (
//               <tr key={index} className="hover:bg-gray-50">
//                 <td className="p-3 border-b border-r text-gray-700 text-sm">{customer.name}</td>
//                 <td className="p-3 border-b border-r text-gray-700 text-sm">{customer.email}</td>
//                 <td className="p-3 border-b border-r text-gray-700 text-sm">{customer.phone}</td>
//                 <td className="p-3 border-b border-r text-gray-700 text-sm">{customer.joinDate}</td>
//                 <td className="p-3 border-b border-r">
//                   <span
//                     className={`px-3 py-1 rounded-full text-white text-sm flex items-center justify-center min-w-[80px] ${
//                       customer.status === "Active" ? "bg-green-500" : "bg-red-500"
//                     }`}
//                   >
//                     {customer.status}
//                   </span>
//                 </td>
//                 <td className="p-3 border-b flex justify-center text-sm">
//                   <select
//                     className="border border-gray-300 rounded px-2 py-1"
//                     value={customer.status === "Active" ? "Unblock" : "Block"}
//                     onChange={(e) => handleStatusChange(index, e.target.value)}
//                   >
//                     <option value="Unblock">Unblock</option>
//                     <option value="Block">Block</option>
//                   </select>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default UserSellers;

import React, { useState } from "react";
import { FaUserCheck, FaUserSlash } from "react-icons/fa";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { RxLapTimer } from "react-icons/rx";
import { FaRegCalendarAlt } from "react-icons/fa";
import SellerRegModal from "../../components/AdminModal/SellerRegModal";
import { Link } from "react-router-dom";

function UserSellers() {
  const [filter, setFilter] = useState("All");

  // Sample data
  const customers = [
    {
      name: "Name 1",
      mail: "Mail ID",
      joinDate: "10/11/2024",
      phone: "Number",
      status: "Inactive",
    },
    {
      name: "Name 2",
      mail: "Mail ID",
      joinDate: "10/11/2024",
      phone: "Number",
      status: "Inactive",
    },
    {
      name: "Name 3",
      mail: "Mail ID",
      joinDate: "10/11/2024",
      phone: "Number",
      status: "Active",
    },
    {
      name: "Name 4",
      mail: "Mail ID",
      joinDate: "10/11/2024",
      phone: "Number",
      status: "Inactive",
    },
    {
      name: "Name 5",
      mail: "Mail ID",
      joinDate: "10/11/2024",
      phone: "Number",
      status: "Pending",
    },
    {
      name: "Name 6",
      mail: "Mail ID",
      joinDate: "10/11/2024",
      phone: "Number",
      status: "Inactive",
    },
    {
      name: "Name 7",
      mail: "Mail ID",
      joinDate: "10/11/2024",
      phone: "Number",
      status: "Inactive",
    },
  ];

  // Filter customers based on the selected filter
  const filteredCustomers =
    filter === "All"
      ? customers
      : customers.filter((customer) => customer.status === filter);

  return (
    <div className="container mx-auto p-4">
      
      {/* Add Customer Button */}
      <div className="mb-4 flex justify-end">
        <SellerRegModal />
      </div>

      {/* Tabs Section */}
      <div className="mb-5 flex w-full items-center justify-between border-b border-gray-300">
        <button
          onClick={() => setFilter("All")}
          className={`flex flex-col items-center gap-1 ${
            filter === "All" ? "text-green-600" : "text-gray-400"
          }`}
        >
          <div className="flex items-center gap-2">
            <MdOutlineAccountBalanceWallet className="text-xl" />
            <span className="font-semibold">All</span>
          </div>
          {filter === "All" && <div className="h-1 w-full bg-green-600"></div>}
        </button>

        <button
          onClick={() => setFilter("Pending")}
          className={`flex flex-col items-center gap-1 ${
            filter === "Pending" ? "text-green-600" : "text-gray-400"
          }`}
        >
          <div className="flex items-center gap-2">
            <RxLapTimer className="text-xl" />
            <span className="font-medium">Pending</span>
          </div>
          {filter === "Pending" && (
            <div className="h-1 w-full bg-green-600"></div>
          )}
        </button>

        <button
          onClick={() => setFilter("Active")}
          className={`flex flex-col items-center gap-1 ${
            filter === "Active" ? "text-green-600" : "text-gray-400"
          }`}
        >
          <div className="flex items-center gap-2">
            <FaUserCheck className="text-xl" />
            <span className="font-medium">Active</span>
          </div>
          {filter === "Active" && (
            <div className="h-1 w-full bg-green-600"></div>
          )}
        </button>

        <button
          onClick={() => setFilter("Inactive")}
          className={`flex flex-col items-center gap-1 ${
            filter === "Inactive" ? "text-green-600" : "text-gray-400"
          }`}
        >
          <div className="flex items-center gap-2">
            <FaUserSlash className="text-xl" />
            <span className="font-medium">Inactive</span>
          </div>
          {filter === "Inactive" && (
            <div className="h-1 w-full bg-green-600"></div>
          )}
        </button>
      </div>

      {/* Table Section */}
      <div className="mt-4 overflow-x-auto">
        <table className="w-full text-left">
          <thead>
            <tr>
              <th className="text-sm font-medium text-green-500">
                Company Name
              </th>
              <th className="px-4 py-3 text-sm font-medium text-green-500">
                Location
              </th>
              <th className="px-4 py-3 text-sm font-medium text-green-500">
                Brand
              </th>
              <th className="px-4 py-3 text-sm font-medium text-green-500">
                Join date
              </th>
              <th className="px-4 py-3 text-sm font-medium text-green-500">
                status
              </th>

              <th className="px-4 py-3 text-sm font-medium text-green-500">
                Sub Admin
              </th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {filteredCustomers.map((customer, index) => (
              <tr key={index}>
                <td>
                  <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                    {customer.companyname || "Company Name"}
                  </div>
                </td>

                <td className="px-4 py-3">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                    {customer.name || "Name"}
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                    {customer.mail || "Mail ID"}
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                    {customer.joinDate || "10/11/2024"}
                    <FaRegCalendarAlt className="text-base text-gray-400" />
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                    {customer.brand || "Brand"}
                  </div>
                </td>

                <td className="px-4 py-3">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                    {customer.status || "Inactive"}
                  </div>
                </td>
                <td className="px-4 py-3 text-right">
                  <Link
                    to="/admin_seller_view"
                    className="rounded-lg border border-green-600 px-4 py-2 text-sm font-medium text-green-600 hover:bg-green-100"
                  >
                    VIEW
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserSellers;
